import React, { PropTypes, Component } from 'react'
import unescape from 'unescape';
import { getAwards }  from '../../store/reducers';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import SectionTitle from '../../components/resorthome/sectiontitle';
import Arrow from 'react-icons/lib/io/android-arrow-forward';
import style from './style.css';

class Awards extends Component {

    componentWillMount() {
        if(! this.props.awards) {
            this.props._getAwards();
        }
    }

    render() {
        const awards = this.props.awards
        const items = awards && awards.awards
        const item_width = 75
        const items_length = items && items.length
        const widths = {
            "Trust You": 150,
            "Travel Life Gold Award": 100,
            "Primo Award": 60,
            "HolidayCheck Quality Selection": 100,
            "Zoover Award": 140,
            "Zoover Award Gold": 100,
            "Zoover Award Silver": 100,
            "Zoover Award Bronze": 100,
            "Zoover - Recommended": 100,
            "Zoover - Highly Recommended": 100,
            "Top 100 – by Tophotels.ru": 100,
            "Cristal Certificates": 100,
        }
        const scroll_width = items && items.filter((node) => node.title ).map((node) => (widths[node.title.trim()] ? widths[node.title.trim()] : 80) + 10 ).reduce((a, b) => a + b, 0);
        return (
            <div className={ style.awardsContainer }>
                <SectionTitle title={ awards && awards.short }/>
                <div className={ style.intro } dangerouslySetInnerHTML={ { __html: awards && unescape(awards.body) } } />
                <div className={ style.scroller } style={{ height: '100px' }}>
                {items &&
                    <div style={{ width: `${scroll_width}px`, height: '100px'}} >
                        { items.map((award) =>
                        <div key={ award.id } className={ style.item } style={ { width: widths[award.title.trim()] || item_width } } title={award.title.trim()}>
                            <Link to={`/awards/${award.title.replace(/[\W\-_]/g, "_")}/${award.db_id}`}>
                                <span className={ style.helper }></span>
                                <img src={ `https://www.sunrise-resorts.com${award.photo.photo_uri}`} />
                            </Link>
                        </div>
                        
                        )}
                    </div>
                }
                </div>
            { !(this.props.showAll===false) &&
                <div className={ style.allAwardsContainer}>
                    <h4>Awards</h4>
                    <Link to={`/awards`}> All Awards <Arrow/></Link>
                </div>
            }
            </div>
        )
    }
}

export default connect( 
    state =>({
        awards: state.app.awards
    }),
    dispatch => { 
    return { 
        _getAwards: () => { dispatch(getAwards()) } ,
    } 
    }
)(Awards);



// WEBPACK FOOTER //
// ./src/containers/awards/index.js